import { useEffect } from 'react'

// TODO Drop this hook in React 19
export function useDocumentTitle(title: string) {
	useEffect(restoreOriginal, [])

	useEffect(() => {
		document.title = title
	}, [title])
}

function restoreOriginal() {
	const initialTitle = document.title
	return () => {
		document.title = initialTitle
	}
}
